import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bd4175e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "example fixed inset-0 z-50 justify-center items-center flex my-auto",
  style: {"max-height":"90%"}
}
const _hoisted_2 = { class: "border-0 rounded-lg h-full shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none" }
const _hoisted_3 = { class: "flex flex-col gap-4 fixed top-5 right-5 w-3/5 lg:w-2/5 xl:w-1/5" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center w-12 bg-green-500\" data-v-2bd4175e><svg class=\"w-6 h-6 text-white fill-current\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\" data-v-2bd4175e><path d=\"M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z\" data-v-2bd4175e></path></svg></div><div class=\"px-4 py-2 -mx-3\" data-v-2bd4175e><div class=\"mx-3\" data-v-2bd4175e><span class=\"font-semibold text-green-500 dark:text-green-400\" data-v-2bd4175e>Success</span><p class=\"text-sm text-gray-600 dark:text-gray-200\" data-v-2bd4175e> Coppy Success </p></div></div>", 2)
const _hoisted_6 = [
  _hoisted_4
]
const _hoisted_7 = { class: "flex items-start justify-between p-5 rounded-t" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl lg:text-3xl font-semibold text-gray-400" }, " การยืนยันการชำระเงิน ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none" }, " × ", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "overflow-x-hidden overflow-y-auto outline-none focus:outline-none h-full"
}
const _hoisted_14 = { class: "border rounded-md border-gray-100 pt-6 pb-10 px-6 mx-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createTextVNode(" เลือกวิธีชำระเงิน "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_16 = {
  key: 0,
  class: "flex gap-4 mb-4"
}
const _hoisted_17 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "hidden",
  type: "radio",
  id: "radSelect",
  name: "radSelect",
  checked: ""
}, null, -1))
const _hoisted_19 = { class: "flex space-x-4 items-center h-full relative" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "flex-1 w-20 flex flex-col text-left gap-1" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_24 = { class: "flex justify-between" }
const _hoisted_25 = {
  key: 0,
  class: "clamp-1 text-gray-500"
}
const _hoisted_26 = {
  key: 1,
  class: "clamp-1 text-gray-500"
}
const _hoisted_27 = { class: "flex flex-col text-left gap-1" }
const _hoisted_28 = { class: "text-sm text-gray-500 opacity-70" }
const _hoisted_29 = {
  key: 0,
  class: "text-md text-gray-500 font-semibold"
}
const _hoisted_30 = {
  key: 1,
  class: "text-md text-gray-500 font-semibold"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(22141 4199)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_2086",
      "data-name": "Rectangle 2086",
      width: "24",
      height: "24",
      transform: "translate(-22141 -4199)",
      fill: "#fff",
      opacity: "0"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Icon_awesome-copy",
      "data-name": "Icon awesome-copy",
      d: "M11.438,16.014v1.43a.858.858,0,0,1-.858.858H.858A.858.858,0,0,1,0,17.443V4.289a.858.858,0,0,1,.858-.858H3.432v10.58a2,2,0,0,0,2,2Zm0-12.3V0H5.433a.858.858,0,0,0-.858.858V14.012a.858.858,0,0,0,.858.858h9.723a.858.858,0,0,0,.858-.858V4.575H12.3A.86.86,0,0,1,11.438,3.717Zm4.324-1.109L13.405.251A.858.858,0,0,0,12.8,0h-.217V3.432h3.432V3.215a.858.858,0,0,0-.251-.607Z",
      transform: "translate(-22137.008 -4196.15)",
      fill: "#bababa"
    })
  ])
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "hidden",
  type: "radio",
  id: "radSelect",
  name: "radSelect"
}, null, -1))
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex space-x-4 items-center h-full relative" }
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "w-full flex flex-col text-left gap-1" }
const _hoisted_40 = {
  key: 0,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_41 = { class: "flex justify-between" }
const _hoisted_42 = {
  key: 0,
  class: "clamp-1 text-gray-500"
}
const _hoisted_43 = {
  key: 1,
  class: "clamp-1 text-gray-500"
}
const _hoisted_44 = { class: "flex flex-col text-left gap-1" }
const _hoisted_45 = { class: "text-sm text-gray-500 opacity-70" }
const _hoisted_46 = {
  key: 0,
  class: "text-md text-gray-500 font-semibold"
}
const _hoisted_47 = {
  key: 1,
  class: "text-md text-gray-500 font-semibold"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(22141 4199)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_2086",
      "data-name": "Rectangle 2086",
      width: "24",
      height: "24",
      transform: "translate(-22141 -4199)",
      fill: "#fff",
      opacity: "0"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Icon_awesome-copy",
      "data-name": "Icon awesome-copy",
      d: "M11.438,16.014v1.43a.858.858,0,0,1-.858.858H.858A.858.858,0,0,1,0,17.443V4.289a.858.858,0,0,1,.858-.858H3.432v10.58a2,2,0,0,0,2,2Zm0-12.3V0H5.433a.858.858,0,0,0-.858.858V14.012a.858.858,0,0,0,.858.858h9.723a.858.858,0,0,0,.858-.858V4.575H12.3A.86.86,0,0,1,11.438,3.717Zm4.324-1.109L13.405.251A.858.858,0,0,0,12.8,0h-.217V3.432h3.432V3.215a.858.858,0,0,0-.251-.607Z",
      transform: "translate(-22137.008 -4196.15)",
      fill: "#bababa"
    })
  ])
], -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("* กรุณาเลือกวิธีชำระเงิน"), -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 0,
  class: "border rounded-md border-gray-100 p-6 mx-4 mt-4 flex flex-col sm:flex-row gap-4"
}
const _hoisted_55 = { class: "flex-1 flex flex-col gap-2" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "" }, "รายละเอียดการชำระเงิน", -1))
const _hoisted_57 = { class: "flex flex-col space-y-2" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" จำนวนเงิน "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_59 = { class: "w-full relative" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("* กรุณากรอกจำนวนเงิน"), -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { class: "flex gap-4" }
const _hoisted_64 = { class: "flex flex-col space-y-2" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" วันที่ชำระ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_66 = { class: "w-full relative" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500 absolute" }, /*#__PURE__*/_toDisplayString("* กรุณากรอกวันที่ชำระ"), -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "flex flex-col space-y-2 flex-wrap" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" เวลาที่ชำระ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_72 = { class: "relative" }
const _hoisted_73 = { class: "flex flex-row space-x-1 items-end" }
const _hoisted_74 = { class: "flex items-end gap-2 w-full" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "น.", -1))
const _hoisted_76 = { key: 0 }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500 absolute" }, /*#__PURE__*/_toDisplayString("* กรุณากรอกเวลาที่ชำระ"), -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "flex flex-col space-y-2" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" แนบไฟล์ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_81 = { class: "relative" }
const _hoisted_82 = { class: "flex gap-2 items-center" }
const _hoisted_83 = ["src"]
const _hoisted_84 = { key: 0 }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("* กรุณาอัพโหลดสลิป"), -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("- ประเภทของไฟล์ไม่ถูกต้อง (รองรับเฉพาะ jpg, jpeg, png)"), -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("- ไฟล์ของคุณขนาดเกิน 2.0 MB"), -1))
const _hoisted_90 = [
  _hoisted_88,
  _hoisted_89
]
const _hoisted_91 = {
  key: 0,
  class: "flex items-center gap-2 mt-4"
}
const _hoisted_92 = ["src"]
const _hoisted_93 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 10.155 11.606"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Icon_awesome-trash",
    "data-name": "Icon awesome-trash",
    d: "M9.793.725H7.072L6.859.3A.544.544,0,0,0,6.372,0H3.781A.538.538,0,0,0,3.3.3L3.083.725H.363A.363.363,0,0,0,0,1.088v.725a.363.363,0,0,0,.363.363h9.43a.363.363,0,0,0,.363-.363V1.088A.363.363,0,0,0,9.793.725ZM1.206,10.586a1.088,1.088,0,0,0,1.086,1.02H7.864a1.088,1.088,0,0,0,1.086-1.02L9.43,2.9H.725Z",
    fill: "#9ba3b0"
  })
], -1))
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = {
  key: 0,
  class: "flex flex-col space-x-1 space-y-2"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, "หมายเหตุ", -1))
const _hoisted_98 = { class: "flex-1 flex justify-center" }
const _hoisted_99 = {
  key: 0,
  class: "flex flex-col gap-2 min-w-72 max-w-72"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "QR Code", -1))
const _hoisted_101 = { class: "flex items-center justify-center" }
const _hoisted_102 = ["src"]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "พร้อมเพย์", -1))
const _hoisted_104 = { class: "flex flex-wrap items-center justify-center gap-2" }
const _hoisted_105 = ["href"]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-download text-gray-400 hover:text-green-mint-500 text-base items-center text-center focus:ring-0 focus:outline-none w-3 h-3" }, null, -1))
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = {
  key: 1,
  class: "flex justify-center items-center min-h-64"
}
const _hoisted_109 = ["src"]
const _hoisted_110 = {
  key: 1,
  class: "flex flex-col gap-2"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "QR Code", -1))
const _hoisted_112 = ["src"]
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  class: "svg-inline--fa fa-times fa-w-11",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = { class: "flex flex-col gap-2 items-center justify-center w-full h-full" }
const _hoisted_116 = ["src"]
const _hoisted_117 = {
  key: 0,
  class: "text-gray-300"
}
const _hoisted_118 = {
  key: 1,
  class: "border rounded-md bg-gray-100 p-6 mx-4 mt-4 flex flex-col sm:flex-row gap-4 justify-center items-center",
  style: {"height":"300px"}
}
const _hoisted_119 = { class: "flex items-center justify-center p-6 rounded-b" }
const _hoisted_120 = ["disabled"]
const _hoisted_121 = {
  key: 1,
  class: "opacity-25 fixed inset-0 z-40 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_fileUpload = _resolveComponent("fileUpload")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            style: {"width":"891px","max-height":"863px"},
            class: _normalizeClass(["relative w-full my-6 mx-2 lg:mx-auto min-h-full container", _ctx.selPayment ? 'h-full' : 'h-auto'])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogCopyArr, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: "flex w-full max-w-sm overflow-hidden bg-white rounded-lg shadow-md z-50 dark:bg-gray-800"
                  }, _hoisted_6))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    class: "bullet_main",
                    src: require('@/assets/icon_bullet/summarize.svg'),
                    alt: ""
                  }, null, 8, _hoisted_9),
                  _hoisted_10
                ]),
                _createElementVNode("button", {
                  class: "p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal()))
                }, _hoisted_12)
              ]),
              (_ctx.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      (_ctx.data.paymentAvailableData.length !== 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (_ctx.hasLength(_ctx.data.paymentAvailableData, 'bankDeposit'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (
                    (_ctx.isSelectTypePayment = 'bankDeposit'),
                      _ctx.selectChannel(_ctx.data.paymentAvailableData, 'bankDeposit')
                  )),
                                  class: _normalizeClass(["rounded-md p-2 border", 
                    _ctx.isSelectTypePayment === 'bankDeposit'
                      ? 'border-green-island-500 bg-green-island-100 text-green-island-500'
                      : 'border-gray-300 text-gray-300'
                  ])
                                }, " ธนาคาร ", 2))
                              : _createCommentVNode("", true),
                            (_ctx.hasLength(_ctx.data.paymentAvailableData, 'cash'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    (_ctx.isSelectTypePayment = 'cash'),
                      _ctx.selectChannel(_ctx.data.paymentAvailableData, 'cash')
                  )),
                                  class: _normalizeClass(["rounded-md p-2 border", 
                    _ctx.isSelectTypePayment === 'cash'
                      ? 'border-green-island-500 bg-green-island-100 text-green-island-500'
                      : 'border-gray-300 text-gray-300'
                  ])
                                }, " เงินสด ", 2))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, [
                        (_ctx.paymentList.length == 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_18,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentList, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.paymentMethodId,
                                  class: "border-2 rounded-md border-green-island-500 bg-green-island-100 p-2",
                                  style: {"min-height":"96px"}
                                }, [
                                  _createElementVNode("div", _hoisted_19, [
                                    (item.paymentIconUrl)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "min-w-16 max-w-16 min-h-16 max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                          src: 
                          _ctx.envMedia +
                          '/public/' +
                          (item.paymentMethodType !== 'cash'
                            ? item.paymentIconUrl
                            : 'icons/payment/cash.webp')
                        ,
                                          alt: ""
                                        }, null, 8, _hoisted_20))
                                      : _createCommentVNode("", true),
                                    (!item.paymentIconUrl)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          class: "min-w-16 max-w-16 min-h-16 max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                          src: `${_ctx.envMedia}/public/icons/payment/cash.webp`,
                                          alt: ""
                                        }, null, 8, _hoisted_21))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_22, [
                                      (item.paymentMethodType === 'cash')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(item.paymentAliasName), 1))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createElementVNode("div", _hoisted_24, [
                                              (item.paymentMethodType === 'bankDeposit')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.convertBankName(
                                  item.paymentMethodAttribute.bankAccountName
                                )) + " " + _toDisplayString(item.paymentMethodAttribute.branchName
                                  ? "(" +
                                    item.paymentMethodAttribute.branchName +
                                    ")"
                                  : ""), 1))
                                                : _createCommentVNode("", true),
                                              (item.paymentMethodType === 'promptPay')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_26, " พร้อมเพย์ "))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                              _createElementVNode("p", _hoisted_28, _toDisplayString(item.paymentMethodAttribute.accountName), 1),
                                              (item.paymentMethodType === 'bankDeposit')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.paymentNumber(
                                    item.paymentMethodAttribute.accountNo
                                  )), 1))
                                                : _createCommentVNode("", true),
                                              (item.paymentMethodType === 'promptPay')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.promptPayNumber(
                                    item.paymentMethodAttribute.accountNo,
                                    item.paymentMethodAttribute.promptPayType
                                  )), 1))
                                                : _createCommentVNode("", true)
                                            ])
                                          ], 64))
                                    ]),
                                    (item.paymentMethodType !== 'cash')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          onClick: ($event: any) => (_ctx.copyLink(item)),
                                          class: "inline-flex w-10 justify-center bg-gray-100 p-2 shadow-md rounded-full cursor-pointer right-0"
                                        }, _hoisted_33, 8, _hoisted_31))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_34,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentList, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.paymentMethodId,
                                  onClick: ($event: any) => (_ctx.selectBank(item.paymentMethodId, item)),
                                  class: _normalizeClass([
                      _ctx.selPayment === item.paymentMethodId
                        ? 'border-green-island-500  bg-green-island-100'
                        : ''
                    , "cursor-pointer border-2 rounded-md border-gray-100 p-2"]),
                                  style: {"min-height":"96px"}
                                }, [
                                  _createElementVNode("div", _hoisted_36, [
                                    (item.paymentIconUrl)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "min-w-16 max-w-16 min-h-16 max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                          src: 
                          _ctx.envMedia +
                          '/public/' +
                          (item.paymentMethodType !== 'cash'
                            ? item.paymentIconUrl
                            : 'icons/payment/cash.webp')
                        ,
                                          alt: ""
                                        }, null, 8, _hoisted_37))
                                      : _createCommentVNode("", true),
                                    (!item.paymentIconUrl)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          class: "min-w-16 max-w-16 min-h-16 max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                          src: `${_ctx.envMedia}/public/icons/payment/cash.webp`,
                                          alt: ""
                                        }, null, 8, _hoisted_38))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_39, [
                                      (item.paymentMethodType === 'cash')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(item.paymentAliasName), 1))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createElementVNode("div", _hoisted_41, [
                                              (item.paymentMethodType === 'bankDeposit')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.convertBankName(
                                  item.paymentMethodAttribute.bankAccountName
                                )) + " " + _toDisplayString(item.paymentMethodAttribute.branchName
                                  ? "(" +
                                    item.paymentMethodAttribute.branchName +
                                    ")"
                                  : ""), 1))
                                                : _createCommentVNode("", true),
                                              (item.paymentMethodType === 'promptPay')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_43, " พร้อมเพย์ "))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_44, [
                                              _createElementVNode("p", _hoisted_45, _toDisplayString(item.paymentMethodAttribute.accountName), 1),
                                              (item.paymentMethodType === 'bankDeposit')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.paymentNumber(
                                    item.paymentMethodAttribute.accountNo
                                  )), 1))
                                                : _createCommentVNode("", true),
                                              (item.paymentMethodType === 'promptPay')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(_ctx.promptPayNumber(
                                    item.paymentMethodAttribute.accountNo,
                                    item.paymentMethodAttribute.promptPayType
                                  )), 1))
                                                : _createCommentVNode("", true)
                                            ])
                                          ], 64))
                                    ]),
                                    (item.paymentMethodType !== 'cash')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          onClick: ($event: any) => (_ctx.copyLink(item)),
                                          class: "inline-flex w-10 justify-center bg-gray-100 p-2 shadow-md rounded-full cursor-pointer right-0"
                                        }, _hoisted_50, 8, _hoisted_48))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 10, _hoisted_35))
                              }), 128))
                            ], 64))
                      ]),
                      (_ctx.checkSelectPayment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
                        : _createCommentVNode("", true)
                    ]),
                    (
                _ctx.selPayment &&
                _ctx.dataitempayment &&
                _ctx.dataitempayment.paymentMethodType !== 'cash' &&
                _ctx.currentChannels === 'bankDeposit'
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("div", _hoisted_57, [
                              _hoisted_58,
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_component_currency_input, {
                                  modelValue: _ctx.paymentPrice,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paymentPrice) = $event)),
                                  options: { currency: 'USD', currencyDisplay: 'hidden' }
                                }, null, 8, ["modelValue"]),
                                (_ctx.paymentPriceChk)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_62))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("form", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, [
                                _hoisted_65,
                                _createElementVNode("div", _hoisted_66, [
                                  _createVNode(_component_Calendar, {
                                    id: "calendar-timeDate",
                                    modelValue: _ctx.selectedDate,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDate) = $event)),
                                    showIcon: "",
                                    dateFormat: "dd/mm/yy",
                                    onDateSelect: _ctx.validator,
                                    onInput: _ctx.validator
                                  }, null, 8, ["modelValue", "onDateSelect", "onInput"]),
                                  (_ctx.crtlDateChk)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, _hoisted_69))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _hoisted_71,
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("div", _hoisted_73, [
                                    _createElementVNode("div", _hoisted_74, [
                                      _createVNode(_component_Calendar, {
                                        id: "calendar-timeonly",
                                        modelValue: _ctx.selectedTime,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTime) = $event)),
                                        timeOnly: "",
                                        showIcon: "",
                                        icon: "pi pi-clock",
                                        onDateSelect: _ctx.validator,
                                        onInput: _ctx.validator
                                      }, null, 8, ["modelValue", "onDateSelect", "onInput"]),
                                      _hoisted_75
                                    ])
                                  ]),
                                  (_ctx.crtlTimeChk)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, _hoisted_78))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                              _hoisted_80,
                              _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("button", {
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.$refs.uploadImage.clickFile && _ctx.$refs.uploadImage.clickFile(...args))),
                                  class: "btn_upload_mini",
                                  style: {"height":"40px"}
                                }, [
                                  _createElementVNode("div", _hoisted_82, [
                                    _createElementVNode("img", {
                                      class: "w-4",
                                      src: require('@/assets/images/upload_image.svg'),
                                      alt: ""
                                    }, null, 8, _hoisted_83),
                                    _createTextVNode(" อัพโหลดรูปภาพ ")
                                  ])
                                ]),
                                _createVNode(_component_fileUpload, {
                                  ref: "uploadImage",
                                  class: "hidden",
                                  onUploadFile: _ctx.getLogoUrl,
                                  onFileName: _ctx.getFileName
                                }, null, 8, ["onUploadFile", "onFileName"]),
                                (_ctx.checkUploadimg)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, _hoisted_86))
                                  : _createCommentVNode("", true),
                                (_ctx.checkUploadimgType)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, _hoisted_90))
                                  : _createCommentVNode("", true)
                              ]),
                              (
                      _ctx.dataitempayment.paymentMethodType === 'promptPay' ||
                      (_ctx.dataitempayment.paymentMethodType === 'bankDeposit' &&
                        _ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl !==
                          '')
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                    _createElementVNode("img", {
                                      class: "object-contain w-16 h-14",
                                      src: 
                        _ctx.dataslipimageUrl
                          ? _ctx.prefixUrlImage + _ctx.dataslipimageUrl
                          : require('@/assets/images/upload_image.svg')
                      ,
                                      alt: ""
                                    }, null, 8, _hoisted_92),
                                    (_ctx.dataslipimageUrl)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                          _createTextVNode(_toDisplayString(_ctx.fileName) + " ", 1),
                                          _createElementVNode("div", {
                                            onClick: _cache[7] || (_cache[7] = ($event: any) => {
                          _ctx.$refs.uploadImage.deleteUrl();
                          _ctx.deleteUrlImage();
                        })
                                          }, _hoisted_95)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (
                    _ctx.dataitempayment.paymentMethodType === 'bankDeposit' &&
                    _ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl ===
                      '' &&
                    _ctx.dataitempayment.paymentMethodType !== 'promptPay'
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                  _hoisted_97,
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.note) = $event)),
                                    class: "resize-none focus:ring-green-island-500 focus:ring-2 focus:border-transparent border rounded-md border-gray-100 p-4"
                                  }, null, 512), [
                                    [_vModelText, _ctx.note]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_98, [
                            (_ctx.dataitempayment.paymentMethodType === 'promptPay')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.promptPayQrCodeImg)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                        _hoisted_100,
                                        _createElementVNode("div", _hoisted_101, [
                                          _createElementVNode("img", {
                                            class: "object-contain w-full bg-gray-100",
                                            src: _ctx.promptPayQrCodeImg,
                                            style: {"width":"250px","height":"250px"},
                                            alt: ""
                                          }, null, 8, _hoisted_102)
                                        ]),
                                        _hoisted_103,
                                        _createElementVNode("div", _hoisted_104, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.dataitempayment.paymentMethodAttribute?.accountName), 1),
                                          _createElementVNode("div", null, "(ยอดชำระ " + _toDisplayString(_ctx.paymentPrice) + ")", 1),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("a", {
                                              target: "_blank",
                                              href: _ctx.promptPayQrCodeImg,
                                              download: ""
                                            }, _hoisted_107, 8, _hoisted_105)
                                          ])
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                        _createElementVNode("img", {
                                          class: "w-32 h-32",
                                          src: require('@/assets/images/animation_loading.gif')
                                        }, null, 8, _hoisted_109)
                                      ]))
                                ], 64))
                              : _createCommentVNode("", true),
                            (
                    _ctx.dataitempayment.paymentMethodType === 'bankDeposit' &&
                    _ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl !== ''
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                  _hoisted_111,
                                  _createElementVNode("img", {
                                    class: "rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                    src: `${_ctx.prefixUrlImage}public/${_ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl}`,
                                    style: {"height":"322px","width":"182px"},
                                    alt: ""
                                  }, null, 8, _hoisted_112)
                                ]))
                              : _createCommentVNode("", true),
                            (
                    _ctx.dataitempayment.paymentMethodType !== 'promptPay' &&
                    _ctx.dataitempayment.paymentMethodType === 'bankDeposit' &&
                    _ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl === ''
                  )
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.$refs.uploadImage.clickFile && _ctx.$refs.uploadImage.clickFile(...args))),
                                  class: "cursor-pointer flex justify-center items-center relative rounded-md border-2 border-gray-200",
                                  style: {"width":"201px","background":"rgb(247 247 247)","height":"311px"}
                                }, [
                                  (_ctx.dataslipimageUrl)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => {
                      _ctx.$refs.uploadImage.deleteUrl();
                      _ctx.deleteUrlImage();
                    }),
                                        class: "absolute top-1 right-2 w-4 text-red-500 cursor-pointer"
                                      }, _hoisted_114))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_115, [
                                    _createElementVNode("img", {
                                      class: _normalizeClass(["object-contain mx-auto", _ctx.dataslipimageUrl ? 'w-full h-full' : '']),
                                      src: 
                        _ctx.dataslipimageUrl
                          ? _ctx.prefixUrlImage + _ctx.dataslipimageUrl
                          : require('@/assets/images/upload_image.svg')
                      ,
                                      alt: ""
                                    }, null, 10, _hoisted_116),
                                    (!_ctx.dataslipimageUrl)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_117, " รูปหลักฐานการโอน "))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (
                _ctx.dataitempayment &&
                _ctx.dataitempayment.paymentMethodType === 'cash' &&
                _ctx.currentChannels === 'cash'
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, " กรุณาชำระเงินสดที่เคาน์เตอร์ "))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("button", {
                  class: "text-green-island-500 bg-gray-200 hover:bg-gray-300 active:bg-gray-300 font-bold uppercase text-sm px-10 py-3 rounded outline-none focus:outline-none mr-4 mb-1 ease-linear transition-all duration-150",
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleModal()))
                }, " ยกเลิก "),
                _createElementVNode("button", {
                  class: _normalizeClass(["text-gray-200 rounded-md bg-green-island-500 hover:bg-green-island-600 background-transparent font-bold uppercase px-14 py-3 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150", _ctx.saveDisabled ? 'opacity-25' : '']),
                  type: "button",
                  disabled: _ctx.saveDisabled,
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.btnOkClick()))
                }, " แจ้งการชำระเงิน ", 10, _hoisted_120)
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_121))
      : _createCommentVNode("", true)
  ]))
}